module.exports = __webpack_public_path__ + "static/q4answer1_bushland_wishmas-c5386e8d46061e41e0f873cebae634c2.jpg";